export default "__VITE_ASSET__sDYYmSg6__"